module.exports = __webpack_public_path__ + "img/icon-iso9001.3f312a44.png";